import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import styles from './ConfirmationScreen.module.scss';
import PageHeading from '../../../common/components/PageHeading';
import SubSection from '../../../common/components/SubSection';
import ArticleList from '../../../common/components/ArticleList';
import EventListingsEventSummaryBox from '../components/EventListingsEventSummaryBox';
import { confirmationScreenArticles } from '../constants';
import { formatDate } from '../helpers/dateUtils';

const ConfirmationScreen = () => {
  const { globalState: state, initialLoad } = useOutletContext();
  const { eventListingPurchase: eventObj } = state ?? {};
  const { token } = useParams();
  const { site, eventListingContactEmail } = window.eventListings;

  if (initialLoad) return null;

  return (
    <div className="column row">
      <div className={styles['order-number']}>Order number: {token}</div>

      <PageHeading title="Purchase Confirmation">
        Thank you for promoting your event <i>{eventObj.title}</i> on {site.name}.
        <br />
        You should be receiving an order confirmation email shortly. Please direct all
        event promotion questions to&nbsp;
        <a href={`mailto:${eventListingContactEmail}`}>{eventListingContactEmail}</a>.
      </PageHeading>

      <EventListingsEventSummaryBox
        title={eventObj.title}
        url="/events"
        imgSrc={eventObj.imageUrl}
        publishDateString={formatDate(eventObj.publishDate)}
      />

      <div className={styles['changes-blurb']}>
        Need to make changes or remove your event promotion? You can&nbsp;
        <a href={eventObj.selfserviceDetailsUrlWithToken}>manage it here</a>.
      </div>

      <SubSection title="RESOURCES" extraHeaderClass="header--sidebar-ified">
        <ArticleList
          contentItems={confirmationScreenArticles}
        />
      </SubSection>
    </div>
  );
};

export default ConfirmationScreen;
